// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"325":"9f0ff194","328":"d92b237b","396":"a1fd7a97"}[chunkId] + ".chunk.js";
};